import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  flex-shrink: 0;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  border-left: 1px solid ${({ theme: { token } }) => `${token.colorBorderSecondary}44`};

  @media (max-width: 900px) {
    display: none;
  }
`;

export const Content = styled.div<{ theme: { token: GlobalToken } }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  padding: ${({ theme: { token } }) => token.padding}px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: ${({ theme: { token } }) => token.marginXXS + token.paddingXXS}px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme: { token } }) => token.colorTextQuaternary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme: { token } }) => token.colorTextTertiary};
  }
`;

export const Section = styled.div<{ $hasDivider?: boolean; theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { token } }) => token.paddingXS}px;
  ${({ $hasDivider, theme: { token } }) =>
    $hasDivider ? `border-bottom: 1px solid ${token.colorBorderSecondary}44;` : ''}
  margin-bottom: ${({ $hasDivider, theme: { token } }) => ($hasDivider ? token.marginLG : 0)}px;
  padding-bottom: ${({ $hasDivider, theme: { token } }) => ($hasDivider ? token.paddingLG : token.paddingXS)}px;
`;

export const SectionLabel = styled.p<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  margin: 0 0 ${({ theme: { token } }) => token.marginXS}px 0;
  padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConversationItem = styled.div<{ $isActive: boolean; theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  padding: ${({ theme: { token } }) => token.paddingXS}px;
  border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-height: 34px;

  background-color: ${({ $isActive, theme: { token } }) => ($isActive ? token.colorFillTertiary : 'transparent')};

  &:hover {
    background-color: ${({ $isActive, theme: { token } }) =>
      $isActive ? token.colorFillSecondary : token.colorFillQuaternary};
  }

  svg {
    flex-shrink: 0;
  }

  .anticon {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    flex-shrink: 0;
  }
`;

export const ConversationTitle = styled.p<{ $isPrimary?: boolean; theme: { token: GlobalToken } }>`
  flex: 1;
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-weight: ${({ $isPrimary, theme: { token } }) => ($isPrimary ? token.fontWeightStrong : 400)};
  color: ${({ $isPrimary, theme: { token } }) => ($isPrimary ? token.colorPrimary : token.colorText)};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
